import Vue from 'vue'
import VueRouter from 'vue-router'
import {staticRoutes} from './static-routes'
import store from '../store'

function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}


function getTargetComponent(argu) {
  return new Promise((resolve, reject) => {
    try {
      if (!argu) {
        resolve(null)
      }
      if (typeof argu.components.default === 'function') {
        argu.components.default().then(res => {
          resolve(res.default.name)
        }).catch(error => {
          reject(error)
        })
      } else {
        resolve(argu.components.default.name)
      }
    } catch (error) {
      reject(error)
    }
  })
}

function navigate (target, to, next) {
  if (to.path === '/' || to.path === '/sso') {
    next();
  }else {
    if (to.matched.length > 0) {
      if (to.path === '/login') {
        resetRouter()
      }
      next()
    } else {
      next('/404')
    }
  }
}

// Uncaught (in promise) NavigationDuplicated解决方法
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routerConfig = {
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: staticRoutes,
}

const createRouter = () => new VueRouter(routerConfig)
const router = createRouter()

router.beforeEach((to, from, next) => {
  getTargetComponent(to.matched[0]).then(target => {
    store.commit('app/clearToken') // 取消当前页面未完成的网络请求
    navigate(target, to, next)
  }).catch(err => {
    console.log(new Error('function getTargetComponent error!'))
    console.log(err)
  })
})

export default router
